import * as React from 'react'

import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'
import {
  MAX_AVATAR_HEIGHT,
  MAX_AVATAR_WIDTH,
  TWO_MB,
} from '~/client/src/shared/utils/fileValidationHelper'

import ProjectImageField from './ProjectImageField'

interface IProps {
  projectLogoUrl: string
  projectId: string
  isNewProjectSelected: boolean
  isProjectLogoChanged: boolean
  onProjectLogoChange: (logoUrl: string) => void
  onProjectLogoSave: () => void
  renderDoneButton(
    clickHandler: () => void,
    isHidden?: boolean,
    isDisabled?: boolean,
  ): JSX.Element
}

const ProjectLogoBlock: React.FC<IProps> = observer(
  ({
    projectLogoUrl,
    projectId,
    isNewProjectSelected,
    isProjectLogoChanged,
    onProjectLogoChange,
    onProjectLogoSave,
    renderDoneButton,
  }: IProps) => {
    return (
      <div className="tw:flex tw:items-start tw:gap-3 tw:px-[30px] tw:py-2">
        <div className="tw:w-[350px]">
          <ProjectImageField
            imageUrl={projectLogoUrl}
            projectId={projectId}
            label={Localization.translator.projectLogo}
            alt={Localization.translator.image}
            onChange={onProjectLogoChange}
            maxFileSize={TWO_MB}
            maxWidth={MAX_AVATAR_WIDTH}
            maxHeight={MAX_AVATAR_HEIGHT}
            shoulOmitCreateLog
          />
        </div>
        {!isNewProjectSelected &&
          renderDoneButton(onProjectLogoSave, !isProjectLogoChanged)}
      </div>
    )
  },
)

export default ProjectLogoBlock
